import { reduxKey } from './constants';
// PopoverTypes shared between projects
export var PopoverType;
(function (PopoverType) {
    PopoverType["ADD_TO_COLLECTION_PRIMARY"] = "ADD_TO_COLLECTION_PRIMARY";
    PopoverType["ADD_TO_COLLECTION_SECONDARY"] = "ADD_TO_COLLECTION_SECONDARY";
    PopoverType["ADD_TO_GROUP_PRIMARY"] = "ADD_TO_GROUP_PRIMARY";
    PopoverType["ADD_TO_GROUP_SECONDARY"] = "ADD_TO_GROUP_SECONDARY";
})(PopoverType || (PopoverType = {}));
//# sourceMappingURL=types.js.map